/**
 * Equipment slot identifiers.
 * This type defines all possible equipment slots across body types.
 * New slots can be added here as new body types are introduced.
 */
export type EquipSlot =
  | 'mainHand'
  | 'offHand'
  | 'head'
  | 'body'
  | 'hands'
  | 'legs'
  | 'feet'
  | 'ring1'
  | 'ring2'
  | 'amulet';

/**
 * Registry mapping body types to their available equipment slots.
 * Used by EquipmentService to validate slot access for different entity types.
 */
export const BodyTypeSlots: Record<string, EquipSlot[]> = {
  humanoid: [
    'mainHand',
    'offHand',
    'head',
    'body',
    'hands',
    'legs',
    'feet',
    'ring1',
    'ring2',
    'amulet',
  ],
  // Future body types:
  // mount: ['barding', 'saddle', 'head'],
  // beast: ['collar'],
};

/**
 * Hand slots that accept any item regardless of Equippable component.
 * Non-hand slots require the item to have Equippable with matching validSlots.
 */
export const HAND_SLOTS: EquipSlot[] = ['mainHand', 'offHand'];

/**
 * All valid equipment slots.
 * Used for runtime validation of network payloads.
 */
export const ALL_EQUIP_SLOTS: EquipSlot[] = [
  'mainHand',
  'offHand',
  'head',
  'body',
  'hands',
  'legs',
  'feet',
  'ring1',
  'ring2',
  'amulet',
];
